// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2vVO2","inputDescription":"styles_inputDescription__1k6e1"};